import {
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TableRow,
    Tooltip
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import React, { useCallback } from 'react';
import FormSection from './atom/FormSection';
import { MODAL_TYPE, useModals } from '../hooks/useModal';
import PriceItem from './PriceItem';
import { PlusIcon } from '../icons';

const generateHashChars = len => Math.floor(Math.random() * 16 ** len).toString(16);

export default function PriceItemTable({
    items,
    setItems,
    title = 'Price items',
    bookingFields,
    chainPriceItemFlag
}) {
    const { showModal } = useModals();
    const setItem = useCallback(
        modifiedPriceItem =>
            setItems(
                items.map(item => (item.id === modifiedPriceItem.id ? modifiedPriceItem : item))
            ),
        [items, setItems]
    );
    const removePriceItem = useCallback(
        item =>
            showModal(MODAL_TYPE.CONFIRMATION, {
                title: 'Are you sure you want to remove the field?',
                content:
                    'Removing this field will result in the removal of all connected price rules.',
                confirm: () => setItems(items.filter(f => f.id !== item.id))
                // when we add rules, we need to delete them
            }),
        [items, setItems, showModal]
    );

    return (
        <FormSection title={title}>
            <Table style={{ backgroundColor: 'white' }} size="small">
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: 40 }} />
                        <TableCell>Name</TableCell>
                        <TableCell>Taxable</TableCell>
                        <TableCell>Is fee</TableCell>
                        <TableCell>Account to</TableCell>
                        <TableCell>Net USD</TableCell>
                        <TableCell>Net %</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Rules</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items?.map(item => (
                        <PriceItem
                            key={item.id}
                            item={item}
                            setItem={setItem}
                            removePriceItem={removePriceItem}
                            bookingFields={bookingFields}
                            chainPriceItemFlag={chainPriceItemFlag}
                        />
                    ))}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={10}>
                            <IconButton
                                onClick={() =>
                                    setItems(
                                        items?.concat([
                                            {
                                                id: generateHashChars(12),
                                                name: '',
                                                is_taxable: false,
                                                is_fee: false,
                                                account_to: 'vendor',
                                                net_usd: 0,
                                                net_percentage: 0,
                                                type: 'lowest',
                                                rules: []
                                            }
                                        ])
                                    )
                                }
                            >
                                <Tooltip title="Add new price item">
                                    <PlusIcon color="disabled" />
                                </Tooltip>
                            </IconButton>
                        </TableCell>
                    </TableRow>
                </TableFooter>
            </Table>
        </FormSection>
    );
}
